import React from "react";
import { FormControl, FormHelperText, styled } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const CustomDatePicker = styled(DatePicker)(({ theme }) => ({
  "& .MuiInputBase-input": {
    fontSize: 14,
  },
  "& .MuiOutlinedInput-root": {
    border: "none",
    fontSize: "14px",
    backgroundColor: "transparent",
    fontFamily: "Inter Tight",
    padding: "8px",
    "&.Mui-focused": {
      outline: "none",
    },
    "& .MuiAutocomplete-input": {
      padding: 0,
    },
    "& .MuiAutocomplete-root": {
      backgroundColor: "#fff",
    },
  },
}));

const FieldsetWrapper = styled("fieldset")(({ theme, error }) => ({
  borderRadius: "12px",
  padding: "8px 12px",
  border: error ? "1px solid red" : "1px solid rgba(18, 18, 21, 0.10)",
  backgroundColor: "#fff",
  fontFamily: "Inter Tight",
  transition: "border-color 0.3s ease",
  "&:focus-within": {
    borderColor: theme.palette.primary.main,
  },
}));

const Legend = styled("legend")(({ error }) => ({
  fontSize: "12px",
  fontWeight: "500",
  padding: "0 5px",
  color: error ? "red" : "#0D0D0E",
}));

const CDueDatePicker = ({
  value,
  error,
  helperText,
  label = "Due Date",
  ...props
}) => {
  return (
    <FormControl fullWidth error={error} variant="standard">
      <FieldsetWrapper error={error}>
        {label && <Legend error={error}>{label}</Legend>}
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <CustomDatePicker
            value={value ? new Date(value) : null}
            disabled
            format="MMMM dd, yyyy"
            slotProps={{
              textField: {
                variant: "standard",
                InputProps: { disableUnderline: true },
                sx: { fontSize: "14px" }, 
              },
            }}
            sx={{ width: "100%" }}
            {...props}
          />
        </LocalizationProvider>
      </FieldsetWrapper>

      <FormHelperText error={error} style={{ fontFamily: "Inter Tight" }}>
        {helperText}
      </FormHelperText>
    </FormControl>
  );
};

export default CDueDatePicker;
